module.exports = __webpack_public_path__ + "static/img/bottom.ce2e3beb.png";